<template>
  <div>
    <div class="input-group password-input">
      <input
        :type="password ? 'password' : 'text'"
        class="form-control"
        :placeholder="placeholder"
        v-model="val"
      />
      <a href="#" class="btn" @click.prevent="password = !password">
        <i class="fas me-0 fa-eye" v-if="password"></i>
        <i class="fas me-0 fa-eye-slash" v-if="!password"></i>
      </a>
    </div>
    <input type="hidden" class="form-control d-none" :name="name" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      val: this.value,
      password: true,
    };
  },

  props: {
    value: {
      default() {
        return "";
      },
    },

    placeholder: {
      default() {
        return "Password";
      },
    },

    name: {
      default() {
        return "password";
      },
    },
  },

  watch: {
    val() {
      this.$emit("input", this.val);
    },
  },
};
</script>
